import { useRef } from 'react';
import { get } from 'lodash';
import useDeleteNote from 'src/actions/Case/Contact/Group/useDeleteNote';
import { useInvalidateQueries } from 'src/api/APIHooks';
import { isHttpSuccess } from 'src/api/utils/httpStatus';
import Notifier from 'common/helpers/Notifier';

const useNoteDeletion = (note = {}) => {
  const deleteNoteDialogRef = useRef(null);
  const invalidateQueries = useInvalidateQueries();
  const { deleteRecord: deleteNote } = useDeleteNote();

  const openDeleteDialog = (event) => {
    event.stopPropagation();
    if (deleteNoteDialogRef.current) {
      deleteNoteDialogRef.current.openDialog();
    }
  };

  const cancelDelete = () => {
    if (deleteNoteDialogRef.current) {
      deleteNoteDialogRef.current.closeDialog();
    }
  };

  const confirmDelete = async () => {
    cancelDelete();

    const response = await deleteNote(get(note, 'id'), {});

    if (isHttpSuccess(response.status)) {
      Notifier.dispatch(response.status, 'Note deleted');
      invalidateQueries('notes');
    }
  };

  return {
    cancelDelete,
    confirmDelete,
    deleteNoteDialogRef,
    openDeleteDialog,
  };
};

export default useNoteDeletion;
